import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import PublicHeader from './components/PublicHeader';
import Footer from './components/Footer';

// Marketing pages
import FeaturesPage from './pages/FeaturesPage';
import HowItWorksPage from './pages/HowItWorksPage';
import PricingPage from './pages/PricingPage';
import LandingPage from './pages/LandingPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfUsePage from './pages/TermsOfUsePage';

// Component to handle scroll restoration
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Public Layout Component
function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <PublicHeader />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      
      <Routes>
        {/* Marketing Routes Only - Public */}
        <Route path="/" element={
          <PublicLayout>
            <LandingPage />
          </PublicLayout>
        } />
        <Route path="/features" element={
          <PublicLayout>
            <FeaturesPage />
          </PublicLayout>
        } />
        <Route path="/how-it-works" element={
          <PublicLayout>
            <HowItWorksPage />
          </PublicLayout>
        } />
        <Route path="/pricing" element={
          <PublicLayout>
            <PricingPage />
          </PublicLayout>
        } />
        <Route path="/privacy-policy" element={
          <PublicLayout>
            <PrivacyPolicyPage />
          </PublicLayout>
        } />
        <Route path="/terms-of-use" element={
          <PublicLayout>
            <TermsOfUsePage />
          </PublicLayout>
        } />
      </Routes>
    </Router>
  );
}

export default App; 